import {
  FETCH_PERMISSIONS_START,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAIL,
  FETCH_PERMISSION_VALUE_TYPES_START,
  FETCH_PERMISSION_VALUE_TYPES_SUCCESS,
  FETCH_PERMISSION_VALUE_TYPES_FAIL,
} from './action';

const initialState = {
  permissions: [],
  // формы значений для прав, выдаваемых значением (null - ещё не загружено)
  valueTypes: null,
  isLoading: false,
  err: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_PERMISSIONS_START:
    return {
      ...state,
      isLoading: true
    };
  case FETCH_PERMISSIONS_SUCCESS:
    return {
      ...state,
      permissions: payload,
      isLoading: false
    };
  case FETCH_PERMISSIONS_FAIL:
    return {
      ...state,
      isLoading: false,
      err: payload,
    };
  case FETCH_PERMISSION_VALUE_TYPES_START:
    return {
      ...state,
      isLoading: true
    };
  case FETCH_PERMISSION_VALUE_TYPES_SUCCESS:
    return {
      ...state,
      valueTypes: payload,
      isLoading: false
    };
  case FETCH_PERMISSION_VALUE_TYPES_FAIL:
    return {
      ...state,
      isLoading: false,
      err: payload,
    };
  default:
    return { ...state };
  }
};
